<template>
  <el-container class="filter-container detail-back">
    <el-button type="primary" icon="el-icon-back" @click="goBack">返回</el-button>
  </el-container>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      page: {
        type: String,
        default: ''
      },
      query: {
        type: Object
      },
      interval: {
        type: Number
      }
    },
    methods: {
      goBack() {
        window.clearInterval(this.interval)
        this.$router.push({ name: this.page, query: this.query })
        // this.$router.go(-1)
      }
    }
  }
</script>

<style lang="stylus">
  .detail-back
    .el-button--primary
      background #a5ce1c
      border 1px solid #a5ce1c
</style>
